"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.number.constructor");
var _dialog = _interopRequireDefault(require("@/mixins/dialog"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** mixins */
var _default2 = exports.default = {
  mixins: [_dialog.default],
  props: {
    // 所有下拉options配置
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var defaultForm = {};
    return {
      /** form group */
      formLabelWidth: '120px',
      form: Object.assign({}, defaultForm),
      initForm: Object.assign({}, defaultForm)
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.$t('doubleWeekPlan.title.checkinSuccess');
    }
  },
  methods: {
    // open dialog init
    init: function init(info) {
      var _this = this;
      this.isShowModel = true;
      this.form = Object.assign({}, info);
      this.initForm = Object.assign({}, info);
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });
    },
    // 格式化日期 yyyyMMDD -> yyyy 年 MM 月 DD 日
    formatDate: function formatDate(date) {
      var str = String(Number(date));
      if (str && str.length === 8) {
        var arr = str.split('');
        arr.splice(8, 0, this.$t('common.day'));
        arr.splice(6, 0, this.$t('common.month'));
        arr.splice(4, 0, this.$t('common.year'));
        return arr.join('');
      } else {
        return '';
      }
    },
    // 确认按钮
    saveItem: function saveItem() {
      this.isShowModel = false;
      console.log('填写访店报告', this.form);
      this.$router.push({
        path: '/planModule/storeVisitReport',
        query: {
          storePk: this.form.storePk,
          planTaskInfoPk: this.form.planTaskInfoPk,
          mode: 'edit'
        }
      });
    }
  }
};